import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import RecordPage from './pages/RecordPage';
import AboutLeiSystemPage from './pages/AboutLeiSystemPage';
import AboutOpenLEIsPage from './pages/AboutOpenLEIsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import LOUPage from './pages/LOUPage';
import NotFoundPage from './pages/NotFoundPage';
import { initGA, handleConsentChange } from './utils/analytics';
import AnalyticsProvider from './components/AnalyticsProvider';
import CookieBanner from './components/CookieBanner';

// Create a client
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false
        }
    }
});

function App() {
    useEffect(() => {
        // Initialize Google Analytics
        initGA();
    }, []);

    const handleConsentChangeWrapper = (preferences: {
        necessary: boolean;
        analytics: boolean;
        marketing: boolean;
    }) => {
        // Call the analytics handler
        handleConsentChange(preferences);
        // Re-initialize GA when consent changes (for cases where consent is granted)
        initGA();
    };

    return (
        <QueryClientProvider client={queryClient}>
            <Router>
                <AnalyticsProvider>
                    <ScrollToTop />
                    <div className="min-h-screen bg-gray-50 flex flex-col">
                        <Header />
                        <main className="flex-1">
                            <Routes>
                                <Route path="/" element={<HomePage />} />
                                <Route path="/search" element={<SearchPage />} />
                                <Route path="/record/:lei" element={<RecordPage />} />
                                <Route path="/lou/:louCode" element={<LOUPage />} />
                                <Route path="/the-lei-system" element={<AboutLeiSystemPage />} />
                                <Route path="/about-openleis" element={<AboutOpenLEIsPage />} />
                                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                                {/* Catch-all route for 404 pages */}
                                <Route path="*" element={<NotFoundPage />} />
                            </Routes>
                        </main>
                        <Footer />
                    </div>
                    <CookieBanner onConsentChange={handleConsentChangeWrapper} />
                </AnalyticsProvider>
            </Router>
        </QueryClientProvider>
    );
}

export default App;
